import { createSlice } from '@reduxjs/toolkit';

export const PANEL_MODES = {
  TOC: 'toc',
  STRUCTURE: 'structure',
};

const initialState = {
  leftPanelMode: PANEL_MODES.TOC,
  selectedModuleForSettings: null,
};

const editCourseSlice = createSlice({
  name: 'editCourse',
  initialState,
  reducers: {
    setLeftPanelMode: (state, action) => {
      // If no payload, toggle between TOC and STRUCTURE
      if (action.payload === undefined) {
        state.leftPanelMode = state.leftPanelMode === PANEL_MODES.TOC ? PANEL_MODES.STRUCTURE : PANEL_MODES.TOC;
      } else {
        const validModes = Object.values(PANEL_MODES);
        if (validModes.includes(action.payload)) {
          state.leftPanelMode = action.payload;
        }
      }
    },
    setSelectedModuleForSettings: (state, action) => {
      state.selectedModuleForSettings = action.payload;
    },
  },
});

export const { setLeftPanelMode, setSelectedModuleForSettings } = editCourseSlice.actions;

export default editCourseSlice.reducer;
